module.exports = __webpack_public_path__ + "img/hall-of-fame_6.5c5b7975.jpg";